module.exports = __webpack_public_path__ + "02_short_brown.a305353a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_short_brown.png
// module id = Vo8i
// module chunks = 0